// Humanise a library item's GraphQL __typename into a short kind label, e.g. "ItemMusicVideo" →
// "Music Video", "ItemBook" → "Book". Shown as a subtle pill so a learner can tell a book from a
// podcast at a glance.
export function librarySubtypeLabel(typename: string): string {
  return typename
    .replace(/^Item/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim()
}
